import { experimental_extendTheme as extendTheme } from '@mui/material/styles';
import { deepmerge } from '@mui/utils';
import defaultCoreTheme from '@themes/index';
var direction = 'ltr';
var themeCustomConfig = function () {
    var newColorScheme = {
        colorSchemes: {}
    };
    var coreTheme = deepmerge(defaultCoreTheme('light', direction), newColorScheme);
    return extendTheme(coreTheme);
};
export default themeCustomConfig;
